import { render, staticRenderFns } from "./hexan-plus-brom.vue?vue&type=template&id=bd021b0c&"
import script from "./hexan-plus-brom.vue?vue&type=script&lang=js&"
export * from "./hexan-plus-brom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports